import { useState, useEffect } from "react";

export function useTypewriter(textoAlvo, velocidade = 25) {
  const [textoExibido, setTextoExibido] = useState("");

  useEffect(() => {
    if (!textoAlvo) {
      setTextoExibido("");
      return;
    }

    let i = 0;
    let textoTemp = "";
    setTextoExibido(""); // limpa imediatamente
    const intervalo = setInterval(() => {
      textoTemp += textoAlvo.charAt(i);
      setTextoExibido(textoTemp);
      i++;
      if (i >= textoAlvo.length) clearInterval(intervalo);
    }, velocidade);

    return () => clearInterval(intervalo);
  }, [textoAlvo, velocidade]);

  return textoExibido;
}
